import dayjs from 'dayjs';

export const getLocalStorage = () => {
  try {
    const accessToken = localStorage.getItem('accessToken');
    const refreshToken = localStorage.getItem('tokenRenew');
    const date: string | null = localStorage.getItem('expiredAt');
    const expiredAt = dayjs(date ?? '').isValid() ? dayjs(date) : undefined;
    return {
      accessToken,
      refreshToken,
      expiredAt
    };
  } catch (error) {
    return {};
  }
};

export const setLocalStorage = (token: string, refreshToken: string) => {
  localStorage.setItem('accessToken', token);
  localStorage.setItem('tokenRenew', refreshToken);
};

export const removeLocalStorage = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('tokenRenew');
};
